import { useState } from "react";
import { motion } from "framer-motion";
import { Plus } from "lucide-react";

export default function Faq({ items }) {
  const [open, setOpen] = useState(0);
  return (
    <div className="space-y-3" data-testid="faq-accordion">
      {items.map((item, i) => (
        <div key={i} className="overflow-hidden rounded-2xl border border-secondary/25 bg-card transition-colors duration-300 hover:border-accent/40">
          <button
            onClick={() => setOpen(open === i ? -1 : i)}
            data-testid={`faq-question-${i}`}
            aria-expanded={open === i}
            aria-controls={`faq-panel-${i}`}
            className="flex w-full items-center justify-between gap-4 px-6 py-5 text-left"
          >
            <span className="text-sm md:text-base font-semibold">{item.q}</span>
            <motion.span animate={{ rotate: open === i ? 45 : 0 }} transition={{ duration: 0.25 }}>
              <Plus className="h-5 w-5 shrink-0 text-accent" />
            </motion.span>
          </button>
          <motion.div
            id={`faq-panel-${i}`}
            initial={false}
            animate={{ height: open === i ? "auto" : 0, opacity: open === i ? 1 : 0 }}
            transition={{ duration: 0.3, ease: [0.22, 1, 0.36, 1] }}
            style={{ overflow: "hidden" }}
            aria-hidden={open !== i}
          >
            <p className="px-6 pb-6 text-sm leading-relaxed text-muted-foreground" data-testid={`faq-answer-${i}`}>{item.a}</p>
          </motion.div>
        </div>
      ))}
    </div>
  );
}
